@if(sidebarNotification) {
<div class="notification-sidebar">
  <div class="notification-header">
    <div class="back-button" (click)="toggleSideBarNotification()">
      <mat-icon class="icon-action">arrow_back</mat-icon>
      <span>FECHAR</span>
    </div>
    <div class="back-button">
      <mat-icon class="icon-action" [routerLink]="['my-account/notification']" (click)="toggleSideBarNotification()">
        settings
      </mat-icon>
    </div>
  </div>

  <div class="titleNotification">Notificações</div>
  <hr />

  @for (notification of notificationsUnRead; track notification.id) {

  <div class="cardNotification" [ngClass]="{ globalNotification: notification.global }">
    <div class="notification-header">
      <div class="titleNotification">{{ notification.title }}</div>
      <div class="actions" [hidden]="notification.global">
        <mat-icon class="icon-action" matTooltip="Marcar como lida" (click)="markAsRead(notification.id!)">
          close
        </mat-icon>
      </div>
    </div>
    <div class="textNotification">{{ notification.message }}</div>
    <div class="dateNotification">
      {{ notification.sentAt | date : "dd/MM/yyyy - HH:mm" }}
    </div>
  </div>
  }
</div>
} @else {

<cbc-container [isLoading]="isLoading" 
[showContainer]="!isLoading && !sidebarNotification" 
title="Notificações">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">
  <div class="fullScreen">
    @if(  notificationsUnRead && notificationsUnRead.length > 0) {
    <b>Notificações não lidas</b>
    <hr />
    }
    <br />
    @for (notification of notificationsUnRead; track notification.id) {

    <div class="cardNotification" [ngClass]="{ globalNotification: notification.global }">
      <div class="notification-header">
        <div class="titleNotification">{{ notification.title }}</div>
        <div class="actions" [hidden]="notification.global">
          <mat-icon class="icon-action" [matTooltip]="'Marcar como lida'" (click)="markAsRead(notification.id!)">
            mark_email_unread
          </mat-icon>
          @if(notification.email !== null) {
          <mat-icon class="icon-action" matTooltip="Excluir" (click)="
              notification.id ? deleteNotification(notification.id) : null
            ">
            delete </mat-icon>}
        </div>
      </div>
      <div class="textNotification">{{ notification.message }}</div>
      <div class="dateNotification">
        {{ notification.sentAt | date : "dd/MM/yyyy - HH:mm" }}
      </div>
    </div>
    }

    <br />
    @if(notificationsRead && notificationsRead.length > 0 ) {
    <b>Notificações lidas</b>
    <hr />
    }
    <br />
    @for (notification of notificationsRead; track notification.id) {
    <div class="cardNotification" [ngClass]="{ globalNotification: notification.global }">
      <div class="notification-header">
        <div class="titleNotification">{{ notification.title }}</div>
        <div class="actions" [hidden]="notification.global">
          <mat-icon [matTooltip]="'Lida'">mark_email_read</mat-icon>
          @if(notification.email !== null) {
          <mat-icon class="icon-action" matTooltip="Excluir" (click)="deleteNotification(notification.id!)">
            delete </mat-icon>}
        </div>
      </div>
      <div class="textNotification">{{ notification.message }}</div>
      <div class="dateNotification">
        {{ notification.sentAt | date : "dd/MM/yyyy - HH:mm" }}
      </div>
    </div>
    }
  </div>
</div>
}
} @if(notificationsRead && notificationsRead.length < 1 && notificationsUnRead && notificationsUnRead.length < 1 && !isLoading) { <div class="no-notifications">Você não tem
  Notificações</div>
  }